import { AnalyticsTotalsDto } from '@api/models/analytics/AnalyticsResponseDto';
import { ColumnMetaType } from '@api/models/analytics/ColumnMetaDto';

export type TotalsMetricKey = keyof AnalyticsTotalsDto;

export interface TotalsMetricConfig {
  labelKey: string;
  columnType: ColumnMetaType;
}

export const TOTALS_METRIC_ORDER: readonly TotalsMetricKey[] = ['count', 'completedCount', 'oneTimeCount', 'average', 'median', 'sum'];

const TOTALS_METRIC_KEY_SET: ReadonlySet<string> = new Set(TOTALS_METRIC_ORDER);

export const isTotalsMetricKey = (key: string | null | undefined): key is TotalsMetricKey => !!key && TOTALS_METRIC_KEY_SET.has(key);
